import React from 'react';
import ReactDOM from 'react-dom';
import { CopyToClipboard } from "react-copy-to-clipboard";
import ErrorBoundary from '../ErrorBoundary';

export default class CopyToClipboardBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            copied: false
        }
    }

    render() {
        return (
            <div className="input-group">
                <input type="text" className="form-control" placeholder="" value={this.props.text} style={{ borderRadius: '.25rem' }} readOnly/>
                <CopyToClipboard
                    text={this.props.text}
                    className="input-group-append btn btn-primary btn-xs ml-1"
                    onCopy={(text, result) => {
                        this.setState({ copied: result });
                    }}>
                    <button>{this.state.copied ? 'Copied!' : 'Copy'}</button>
                </CopyToClipboard>
            </div>
        );
    }
}

let CopyToCLipboardElements = document.getElementsByClassName('CopyToClipboard');
if (CopyToCLipboardElements.length > 0) {
    for (let key in CopyToCLipboardElements) {
        if (CopyToCLipboardElements.hasOwnProperty(key) && typeof CopyToCLipboardElements[key].getAttribute === 'function') {
            let text = CopyToCLipboardElements[key].getAttribute('data-text');
            let eventName = CopyToCLipboardElements[key].getAttribute('data-eventName');

            if (text) {
                ReactDOM.render(
                    <ErrorBoundary>
                        <CopyToClipboardBox text={text} eventName={eventName} />
                    </ErrorBoundary>, CopyToCLipboardElements[key]
                );
            }
        }
    }
}
